import { gql } from 'graphql-request';

export const REMOVE_DOWNLOAD_QUERY = gql`
  mutation RemoveDownload($uuid: ID!) {
    removeDownload(input: { uuid: $uuid }) {
      status
      errors {
        fullMessages
      }
    }
  }
`;
